<template>
  <li class="group-reveal" v-bind:class="{ 'is-active': active }">
    <a href="#" class="group-title" v-on:click.prevent="toggle">
      {{ title }}
    </a>
    <ul v-show="active" class="reveal">
      <li
        v-for="item in items"
        v-bind:class="{
          'secondary-group-title': item.href === '##',
          '-empty': item.name === '',
        }"
      >
        <a v-bind:href="item.href" v-bind:target="item.target">{{
          item.name
        }}</a>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: "group-reval",
  props: {
    title: {
      type: String,
    },
    items: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    toggle() {
      if (this.active) {
        return (this.active = false);
      }

      bus.$emit("group-reval:active", false);
      this.$nextTick(() => {
        this.active = !this.active;
      });

      // this.active = (this.active === arg) ? '' : arg;
    },
  },
  created() {
    bus.$on("group-reval:active", (val) => {
      this.active = val;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/components/navigation";

.group-reveal {
  @extend %default-list-style;
  background: none;

  &.is-active {
    background-color: $cc-resmed-bg-gray-5;
    margin: 0 -2rem;

    .group-title {
      color: $cc-resmed-action-red;
      padding-left: 2rem;
      padding-right: 2rem;

      background-position: calc(100% - 2rem) center;
      background-image: url(#{$assets}/images/icon-up-caret-red.svg);

      &:focus {
        opacity: 1;
      }
    }

    ul {
      padding: 0 2rem;
    }

    // cheat border top
    // offset 1px up and down to compensate
    transform: translateY(-1px);
    > * {
      transform: translateY(1px);
    }
    // end
  }

  .group-title {
    @extend %heading-sm;

    background-position: right center;
    background-repeat: no-repeat;
    background-size: 1.5rem 1.5rem;
    background-image: url(#{$assets}/images/icon-down-caret-black.svg);

    @media (max-width: 767px) {
      opacity: 1 !important;
    }
  }

  .reveal {
    li {
      @extend %default-list-style;
      border-color: transparent;
      background-image: none;
      padding-left: 1.25rem;

      a {
        padding: 0.875rem 0;
      }

      &:last-child {
        padding-bottom: 3rem;
      }

      & ~ .secondary-group-title {
        padding-top: 1.5rem;
      }

      &.secondary-group-title {
        padding: 1.5rem 0 0 0;

        &:first-child {
          padding: 0;
        }

        a {
          @extend %body-small;
          text-transform: uppercase;
          color: $cc-resmed-grey-70;
          padding: 0 0 0.325rem 0;

          &:hover,
          &:focus {
            cursor: default;
            opacity: 1;
          }
        }
      }

      // d-none on li
      // :empty pseudo-class on a won't work
      &.-empty {
        display: none;
      }
    }
  }
}
</style>